'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'sparkles';
var width = 640;
var height = 512;
var aliases = [10024];
var unicode = 'f890';
var svgPathData = ['M376 448l72 32 32 72 32-72 72-32-72-32-32-72-32 72-72 32zM408 64l72 32 32 72 32-72 72-32-72-32-32-72-32 72-72 32z', 'M160 192l64-144 64 144 144 64-144 64-64 144-64-144-144-64 144-64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSparkles = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;